module.exports = __webpack_public_path__ + "static/img/5.098a3024.png";